import App from '@/App';
import { Suspense, useEffect, useState } from 'react';
import ErrorBoundary from '../ui/ErrorBoundary';
import LoadingState from '../ui/LoadingState';

const BlankLayout = ({ children }) => {
    const [showLoader, setShowLoader] = useState(true);
    const [contentLoaded, setContentLoaded] = useState(false);

    // Handle initial loading state
    useEffect(() => {
        // Hide loader after a short delay regardless of other conditions
        const loaderTimer = setTimeout(() => {
            setShowLoader(false);
        }, 800);
        
        return () => {
            clearTimeout(loaderTimer);
        };
    }, []);

    // Mark content as loaded when children are rendered
    useEffect(() => {
        if (children) {
            const timer = setTimeout(() => {
                setContentLoaded(true);
                setShowLoader(false);
            }, 100);
            
            return () => clearTimeout(timer);
        }
    }, [children]);

    return (
        <App>
            <div className="text-black dark:text-white-dark min-h-screen">
                {/* Only show loader if content isn't loaded yet */}
                {showLoader && !contentLoaded && <LoadingState fullScreen size="large" />}
                
                <ErrorBoundary>
                    <Suspense fallback={<LoadingState message="Loading..." />}>
                        <div onLoad={() => setContentLoaded(true)}>
                            {children}
                        </div>
                    </Suspense>
                </ErrorBoundary>
            </div>
        </App>
    );
};

export default BlankLayout;
